export default __webpack_public_path__ + "static/pyotr-ef818d9cd4ac65c32fb88a86104e8167.jpg";